import { Link } from "react-router-dom";
import { footerLinks, friendLinks, socialLinks } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-secondary-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-film-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                国产自拍
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              国产自制影视内容展示与资讯平台，汇聚最新国产电影、电视剧与综艺，
              带你发现更多原创好作品。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {socialLinks.map((item) => (
                <span
                  key={item.label}
                  title={`${item.label}：${item.handle}`}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-secondary-300 bg-background-50 text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
                >
                  <i className={`${item.icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-3">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 transition-colors hover:text-accent-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">友情链接</h4>
            <ul className="mt-4 space-y-3">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 transition-colors hover:text-accent-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-primary-500" />
                hello@gczp-film.demo
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-base text-primary-500" />
                中国 · 北京市朝阳区影视产业园
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-base text-primary-500" />
                每日 09:00 - 22:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {year} 国产自拍 GCZP FILM · 本站为前端演示网站，内容均为虚拟演示数据。</p>
          <p className="flex items-center gap-3">
            <span>内容仅供浏览与了解</span>
            <span className="hidden sm:inline">·</span>
            <span>不提供播放与下载</span>
          </p>
        </div>
      </div>
    </footer>
  );
}